/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AccessGrantedUserGroups {
    getFixupPrototypeFunction() { return AccessGrantedUserGroups.fixupPrototype; }

    static newInstance(model: Partial<AccessGrantedUserGroups>): AccessGrantedUserGroups {
        let obj = Object.assign(new AccessGrantedUserGroups(), model);
        AccessGrantedUserGroups.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AccessGrantedUserGroups>): AccessGrantedUserGroups {
        if (!model) return null;
        return AccessGrantedUserGroups.newInstance(<AccessGrantedUserGroups> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AccessGrantedUserGroups) {
        if (!obj) return;

        models.AccessGrantedUserGroups.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AccessGrantedUserGroups): boolean {
        Object.setPrototypeOf(obj, AccessGrantedUserGroups.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User groups explicitly denied access
     */
    user_groups: Array<string>;

}
